export default [
    {
        path: '/admin/academic/sector-profiles',
        name: 'sector-profile',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/sector-profile/index.vue')
    }
]
